import axiosInstance from "./axiosInstance";

// GET all products
export const getProducts = async () => {
  try {
    const response = await axiosInstance.get("/product");
    return response.data.data; // assuming API returns {status, data}
  } catch (error) {
    console.error("Failed to fetch products:", error);
    throw error;
  }
};

